module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "purchaseOrderChangeInfo"
    }
  }, [_c('el-row', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-col', {
    staticClass: "fl",
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.backGo()
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    attrs: {
      "span": 1
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fl searthPart",
    staticStyle: {
      "width": "17%"
    }
  }, [_c('p', {
    staticClass: "headerT"
  }, [_vm._v("采购订单变更信息")]), _vm._v(" "), _c('el-form', {
    ref: "purchaseForm",
    attrs: {
      "model": _vm.purchaseForm,
      "label-width": "120px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "变更编号:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.purchaseForm.code),
      callback: function($$v) {
        _vm.$set(_vm.purchaseForm, "code", $$v)
      },
      expression: "purchaseForm.code"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont hohofast-copy copyBtn",
    on: {
      "click": function($event) {
        return _vm.handleCopy(_vm.purchaseForm.code, $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "作废订单号:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.purchaseForm.pIdOld),
      callback: function($$v) {
        _vm.$set(_vm.purchaseForm, "pIdOld", $$v)
      },
      expression: "purchaseForm.pIdOld"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont hohofast-copy copyBtn",
    on: {
      "click": function($event) {
        return _vm.handleCopy(_vm.purchaseForm.pIdOld, $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新订单号:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.purchaseForm.pId),
      callback: function($$v) {
        _vm.$set(_vm.purchaseForm, "pId", $$v)
      },
      expression: "purchaseForm.pId"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont hohofast-copy copyBtn",
    on: {
      "click": function($event) {
        return _vm.handleCopy(_vm.purchaseForm.pId, $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "创建时间:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.purchaseForm.createTime),
      callback: function($$v) {
        _vm.$set(_vm.purchaseForm, "createTime", $$v)
      },
      expression: "purchaseForm.createTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.purchaseForm.status),
      callback: function($$v) {
        _vm.$set(_vm.purchaseForm, "status", $$v)
      },
      expression: "purchaseForm.status"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注信息:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.purchaseForm.memo),
      callback: function($$v) {
        _vm.$set(_vm.purchaseForm, "memo", $$v)
      },
      expression: "purchaseForm.memo"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "headerT"
  }, [_vm._v("变更内容（变更前)")]), _vm._v(" "), _c('el-form', {
    ref: "purchaseForm",
    attrs: {
      "model": _vm.purchaseForm,
      "label-width": "120px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "供应商:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.purchaseForm.supplierNameOld),
      callback: function($$v) {
        _vm.$set(_vm.purchaseForm, "supplierNameOld", $$v)
      },
      expression: "purchaseForm.supplierNameOld"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账期:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.purchaseForm.paymentTimeOld),
      callback: function($$v) {
        _vm.$set(_vm.purchaseForm, "paymentTimeOld", $$v)
      },
      expression: "purchaseForm.paymentTimeOld"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "采购日期:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.purchaseForm.purchaseTimeOld),
      callback: function($$v) {
        _vm.$set(_vm.purchaseForm, "purchaseTimeOld", $$v)
      },
      expression: "purchaseForm.purchaseTimeOld"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预期交货日期:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.purchaseForm.aogTimeOld),
      callback: function($$v) {
        _vm.$set(_vm.purchaseForm, "aogTimeOld", $$v)
      },
      expression: "purchaseForm.aogTimeOld"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "headerT"
  }, [_vm._v("变更内容（变更后)")]), _vm._v(" "), _c('el-form', {
    ref: "purchaseForm",
    attrs: {
      "model": _vm.purchaseForm,
      "label-width": "120px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "供应商:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.purchaseForm.supplierName),
      callback: function($$v) {
        _vm.$set(_vm.purchaseForm, "supplierName", $$v)
      },
      expression: "purchaseForm.supplierName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账期:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.purchaseForm.paymentTime),
      callback: function($$v) {
        _vm.$set(_vm.purchaseForm, "paymentTime", $$v)
      },
      expression: "purchaseForm.paymentTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "采购日期:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.purchaseForm.purchaseTime),
      callback: function($$v) {
        _vm.$set(_vm.purchaseForm, "purchaseTime", $$v)
      },
      expression: "purchaseForm.purchaseTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预期交货日期:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.purchaseForm.aogTime),
      callback: function($$v) {
        _vm.$set(_vm.purchaseForm, "aogTime", $$v)
      },
      expression: "purchaseForm.aogTime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    staticStyle: {
      "width": "80%"
    }
  }, [_c('el-card', {
    staticClass: "box-card fr",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      },
      "summary-method": _vm.getSummaries,
      "show-summary": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "index",
      "width": "50",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialCoding",
      "label": "物料编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "number",
      "label": "采购数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "price",
      "formatter": _vm.addCommas,
      "label": "采购单价"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "amout",
      "formatter": _vm.addCommas,
      "label": "合计金额"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-23977bfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/purchaseManage/purchaseOrderChangeInfo.vue
// module id = 1604
// module chunks = 0